import * as actionTypes from "../actions/actionTypes";
import { takeEvery } from "redux-saga/effects";
import {
  dashboard,
  getRecentChecks,
  getPendingPayableReport,
  getVendorDownloadLink
} from "./dashBoardSaga";
import { login, authLogin, getPortalMessage, getOutageMessages } from "./loginSaga";

import { getDetails, requestAttachmentSaga } from "./responseDetailSaga";
import { getDocumentDetail } from "./documentDetailSaga";

export function* watchDashboard() {
  yield takeEvery(actionTypes.DASHBOARD, dashboard);
  yield takeEvery(actionTypes.LOGIN, login);
  yield takeEvery(actionTypes.PORTAL_MESSAGE, getPortalMessage);
  yield takeEvery(actionTypes.PORTAL_OUTAGE_MESSAGE, getOutageMessages);
  yield takeEvery(actionTypes.AUTH_LOGIN, authLogin);
  yield takeEvery(actionTypes.GET_RECENT_CHECKS, getRecentChecks);
  yield takeEvery(
    actionTypes.GET_PENDING_PAYABLE_CHECK,
    getPendingPayableReport
  );
  yield takeEvery(actionTypes.GET_VENDOR_DOWNLOAD_LINK, getVendorDownloadLink);
  yield takeEvery(actionTypes.GET_RESPONSE_DETAIL, getDetails);
  yield takeEvery(actionTypes.GET_ATTACHMENTS, requestAttachmentSaga);
  //Document detail
  yield takeEvery(actionTypes.GET_DOCUMENT_DETAIL, getDocumentDetail);
}
